import { render, staticRenderFns } from "./Deportes.view.vue?vue&type=template&id=03f4f1f1"
import script from "./Deportes.view.vue?vue&type=script&lang=js"
export * from "./Deportes.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports